import ProgressStatusSmall from './component.styles'
export default ProgressStatusSmall
